import { topics } from '@/mocks/chiguaData';

const trendIcon = (trend: string) => {
  if (trend === 'hot') return 'ri-fire-fill text-accent-600';
  if (trend === 'up') return 'ri-arrow-up-line text-primary-600';
  return 'ri-arrow-down-line text-foreground-400';
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
            <i className="ri-hashtag text-xl text-accent-600"></i>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 mt-0.5">今日大家都在讨论什么</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="group inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.heat}</span>
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={trendIcon(topic.trend)}></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}